import React from 'react';

import {
  deleteMessage,
  getMessageLogs,
  likeMessage,
  restoreMessage,
  saveMessageChanges,
  selectMessage,
} from '../../../redux/id8/id8Actions';
import MessagesOutput from '../message-output/MessagesOutput';

function CommonMessagesOutput({ bindAction, searchFunction, isShowGenerationForm }) {
  return (
    <MessagesOutput
      bindNextAction={bindAction}
      onSearch={searchFunction}
      onSelect={selectMessage}
      onDelete={deleteMessage}
      onLike={likeMessage}
      onRestore={restoreMessage}
      onSaveMessage={saveMessageChanges}
      getMessageLogs={getMessageLogs}
      maxHeight={isShowGenerationForm ? 'calc(100vh - 536px)' : 'calc(100vh - 356px)'}
    />
  );
}

export default CommonMessagesOutput;
